import React from 'react'
import TitleText from '../components/PageHeading'
import Content from '../components/Content'
import { useEffect } from 'react'
import ContactBanner from '../components/ContactBanner'

export default function About() {

  useEffect(() => {
    document.title = "Om oss";
  });

  return (
    <>
      <TitleText title="Om oss" />
      <ContactBanner />
      <Content showMap={true} />
    </>
  )
}